import ClickableChip from './ClickableChip';

export { Props } from './ClickableChip';
export default ClickableChip;
